import{useState as e,useEffect as o}from"react";var r=()=>{const[r,n]=e(!1);return o((()=>{n(Boolean("undefined"!=typeof window&&window.document&&window.document.createElement))}),[]),{isBrowser:r,isServer:!r}};export{r as default};
